// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-components-flex-FlexUniversalDrawer-module-root {
	height: 100%;
	overflow: hidden;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	    flex-direction: column;
}

.csi-components-flex-FlexUniversalDrawer-module-middleContainer {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: row;
	    flex-direction: row;
	-ms-flex-positive: 1;
	    flex-grow: 1;
	overflow: hidden;
}

.csi-components-flex-FlexUniversalDrawer-module-mainContent {
	-ms-flex-positive: 1;
	    flex-grow: 1;
	overflow: auto;
	position: relative;
}

.csi-components-flex-FlexUniversalDrawer-module-drawer {
	overflow: hidden;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.csi-components-flex-FlexUniversalDrawer-module-button {
	position: absolute;
	z-index: 1;
	display: none;
	background-color: white;
	/* Adjust as needed */
}

.csi-components-flex-FlexUniversalDrawer-module-forceDisplay {
	display: -ms-inline-flexbox !important;
	display: inline-flex !important;
}

.csi-components-flex-FlexUniversalDrawer-module-buttonLabel {
	margin-left: 4px;
	/* Adjust as needed */
}

.csi-components-flex-FlexUniversalDrawer-module-borderLeft {
	border-left: 1px solid #ccc;
	/* Adjust as needed */
}

.csi-components-flex-FlexUniversalDrawer-module-borderRight {
	border-right: 1px solid #ccc;
	/* Adjust as needed */
}

.csi-components-flex-FlexUniversalDrawer-module-borderTop {
	border-top: 1px solid #ccc;
	/* Adjust as needed */
}

.csi-components-flex-FlexUniversalDrawer-module-borderBottom {
	border-bottom: 1px solid #ccc;
	/* Adjust as needed */
}`, "",{"version":3,"sources":["webpack://./src/csi/components/flex/FlexUniversalDrawer.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,gBAAgB;CAChB,oBAAa;CAAb,aAAa;CACb,0BAAsB;KAAtB,sBAAsB;AACvB;;AAEA;CACC,oBAAa;CAAb,aAAa;CACb,uBAAmB;KAAnB,mBAAmB;CACnB,oBAAY;KAAZ,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,oBAAY;KAAZ,YAAY;CACZ,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,aAAa;CACb,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;CACC,sCAA+B;CAA/B,+BAA+B;AAChC;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,2BAA2B;CAC3B,qBAAqB;AACtB;;AAEA;CACC,4BAA4B;CAC5B,qBAAqB;AACtB;;AAEA;CACC,0BAA0B;CAC1B,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;CAC7B,qBAAqB;AACtB","sourcesContent":[".root {\n\theight: 100%;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.middleContainer {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-grow: 1;\n\toverflow: hidden;\n}\n\n.mainContent {\n\tflex-grow: 1;\n\toverflow: auto;\n\tposition: relative;\n}\n\n.drawer {\n\toverflow: hidden;\n\tflex-shrink: 0;\n}\n\n.button {\n\tposition: absolute;\n\tz-index: 1;\n\tdisplay: none;\n\tbackground-color: white;\n\t/* Adjust as needed */\n}\n\n.forceDisplay {\n\tdisplay: inline-flex !important;\n}\n\n.buttonLabel {\n\tmargin-left: 4px;\n\t/* Adjust as needed */\n}\n\n.borderLeft {\n\tborder-left: 1px solid #ccc;\n\t/* Adjust as needed */\n}\n\n.borderRight {\n\tborder-right: 1px solid #ccc;\n\t/* Adjust as needed */\n}\n\n.borderTop {\n\tborder-top: 1px solid #ccc;\n\t/* Adjust as needed */\n}\n\n.borderBottom {\n\tborder-bottom: 1px solid #ccc;\n\t/* Adjust as needed */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `csi-components-flex-FlexUniversalDrawer-module-root`,
	"middleContainer": `csi-components-flex-FlexUniversalDrawer-module-middleContainer`,
	"mainContent": `csi-components-flex-FlexUniversalDrawer-module-mainContent`,
	"drawer": `csi-components-flex-FlexUniversalDrawer-module-drawer`,
	"button": `csi-components-flex-FlexUniversalDrawer-module-button`,
	"forceDisplay": `csi-components-flex-FlexUniversalDrawer-module-forceDisplay`,
	"buttonLabel": `csi-components-flex-FlexUniversalDrawer-module-buttonLabel`,
	"borderLeft": `csi-components-flex-FlexUniversalDrawer-module-borderLeft`,
	"borderRight": `csi-components-flex-FlexUniversalDrawer-module-borderRight`,
	"borderTop": `csi-components-flex-FlexUniversalDrawer-module-borderTop`,
	"borderBottom": `csi-components-flex-FlexUniversalDrawer-module-borderBottom`
};
module.exports = ___CSS_LOADER_EXPORT___;
